/** Тип недоступности контента */
export enum EUnavailableType {
    /** конференция закончилась */
    IS_OVER = 'is-over',
    /** конференция не найдена */
    NOT_FOUND = 'not-found',
    /** запись конференции не найдена */
    RECORD_NOT_FOUND = 'record-not-found',
    /** запись конференции недоступна */
    RECORD_UNAVAILABLE = 'record-unavailable',
    /** нет нужного доступа для просмотра контента */
    RESTRICTED_AREA = 'restricted-area',
}
